import { makeStyles } from "@mui/styles";

const SWITCH_CONTAINER_WIDTH = 86;
const SWITCH_CONTAINER_HEIGHT = 36;
const SWITCH_CONTAINER_SIDE_PADDING = 4;
const SWITCH_CONTAINER_TOP_BOTTOM_PADDING = 3;

const SWITCH_WIDTH = (SWITCH_CONTAINER_WIDTH - SWITCH_CONTAINER_SIDE_PADDING * 2) / 2;
const SWITCH_HEIGHT = SWITCH_CONTAINER_HEIGHT - SWITCH_CONTAINER_TOP_BOTTOM_PADDING * 2;

export const useStyles = makeStyles(() => ({
  //plai change start
  switchContainer: {
    backgroundColor: "#F5F5F5",
    position: "absolute",
    top: "16px",
    right: "80px",
    "@media only screen and (max-width: 600px)": {
      right: "16px",
    },
    "@media only screen and (min-width: 1024px)": {
      top: "24px",
      right: "calc(5% + 16px)",
    },
    padding: 5,
    borderRadius: "10px",
    zIndex: 1,
    overflow: "hidden",
  },
  switch: {
    padding: 5,
    margin: "0 auto",
    justifyContent: "center",
  },
  //plai change end
  switchChecked: {
    color: "#E8192C",
    backgroundColor: "white",
    borderRadius: "8px",
    margin: "0 auto",
    justifyContent: "center",
  },
  switchUnchecked: {
    color: "#999999",
    margin: "0 auto",
    justifyContent: "center",
  },
  switchLabel: {
    width: "100%",
    textAlign: "center",
    fontSize: "1rem",
    fontWeight: 600,
    fontFamily: "Arial",
  },
  langCheckBox: {
    display: "none !important",
  },
  switchContainerHaveNavbar: {
    top: "100px",
    "@media only screen and (min-width: 1024px)": {
      top: "120px",
    },
  },
}));
